/* @flow */

import * as React from 'react';
import styled from 'styled-components';

import FlexBox from '../FlexBox';

const VipBox = styled(FlexBox)`
 font-weight: bold;
 color: ${({ level, theme }) => level === 0 ?
    theme.fontColor2 : theme.highlight};
  ${({ onlyShowLevel, theme }) => !onlyShowLevel ?
    `font-size: 14px; font-weight: bold; color: ${theme.fontColor};` : null}
 `;

type ComponentProps = {
  userInfo: Object,
  i18n: Object,
  onlyShowLevel: boolean,
};

export default
class VipLevel extends React.PureComponent<ComponentProps> {
  static defaultProps = {
    i18n: {},
    onlyShowLevel: true,
  }

  _getVipLevel = () => {
    const { userInfo, i18n, onlyShowLevel } = this.props;
    const { tradeLevel } = userInfo;
    if (!tradeLevel && !onlyShowLevel) return i18n.General || 'General';
    if (!tradeLevel && onlyShowLevel) return 'VIP';
    return `VIP${tradeLevel}`;
  }

  render() {
    const { onlyShowLevel, userInfo } = this.props;
    const { tradeLevel } = userInfo;
    return (
      <VipBox level={tradeLevel} onlyShowLevel={onlyShowLevel}>
        {this._getVipLevel()}
      </VipBox>
    );
  }
}
